module.exports = __webpack_public_path__ + "static/media/glitchLogo.967dd02f.gif";